import { useQuery } from '@tanstack/react-query';
import API from '../../../context/API';

export interface MerchantOption {
  id: string;
  name: string;
}

export const MERCHANTS_LIST_QUERY_KEY = ['stores', 'merchants'] as const;

// Backend: GET /merchant is @Roles('admin') only — only fetch it for the
// admin-create-store flow, never for merchant/merchant_manager users.
export const useMerchantsList = (enabled: boolean) => {
  return useQuery<MerchantOption[]>({
    queryKey: MERCHANTS_LIST_QUERY_KEY,
    queryFn: async () => {
      const res = await API.get('/merchant');
      return res.data.data || [];
    },
    enabled,
    staleTime: 5 * 60 * 1000,
  });
};
